var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"checklist"},_vm._l((_vm.checklist),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"checklist-icon"},[_c('hot-icon',{attrs:{"font-awesome":_vm.icon}})],1),_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }